/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserReward } from '../../models/user-reward';

export interface GetLoyaltyUserReward$Params {
  'Active-Tenant-Identifier': string;
  userId: string;
  rewardId: string;
  time?: string;
}

export function getLoyaltyUserReward(http: HttpClient, rootUrl: string, params: GetLoyaltyUserReward$Params, context?: HttpContext): Observable<StrictHttpResponse<UserReward>> {
  const rb = new RequestBuilder(rootUrl, getLoyaltyUserReward.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('userId', params.userId, {});
    rb.path('rewardId', params.rewardId, {});
    rb.header('time', params.time, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserReward>;
    })
  );
}

getLoyaltyUserReward.PATH = '/loyalty/users/{userId}/rewards/{rewardId}';
